import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'br-expansion-panel',
  templateUrl: './br-expansion-panel.component.html'
})
export class ExpansionPanelComponent implements OnInit {

    @Input() title: String;

    ngOnInit() {

    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/br-expansion-panel/br-expansion-panel.component.ts